import { useMutation } from '@tanstack/react-query';

import type { ApiError, ResetPasswordParams, ResetPasswordResponse } from '@brightlocal/api-client';

import { apiClient } from 'shared/apiClient';

/** React Query mutation hook for submitting a new password with the reset token. */
export const useResetPasswordMutation = () =>
  useMutation<ResetPasswordResponse, ApiError, ResetPasswordParams>({
    mutationFn: (params) => apiClient.auth.resetPassword(params)
  });
